import React, { useEffect, useState, useContext } from "react";
import { getOperatorsL } from "../api";
import { LanguageContext } from "../context/LanguageContext";

const OperatorList2 = ({ id_c, onSelect, value }) => {
  const { t } = useContext(LanguageContext);
  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const res = await getOperatorsL(id_c); // { operators, total }
      setData(res);
    };
    if (id_c) fetchData();
  }, [id_c]);

  if (!data) return <p>{t("MList1") || "Cargando..."}</p>;

  return (
    <select
      className="input1"
      onChange={(e) => onSelect(e.target.value)}
      value={value || ""}
      required
    >
      <option value="">
        -- {t("operator1") || "Selecciona un operador"} --
      </option>
      {data.operators.map((op) => (
        <option key={op.id_operator} value={op.id_operator}>
          {op.id_operator} — {op.name_oper}
        </option>
      ))}
    </select>
  );
};

export default OperatorList2;
